module.exports = __webpack_public_path__ + "img/mcu2.2e503deb.png";